export const ADMIN_ROLES = ["super_admin", "club_admin", "coach", "staff"];

export function userHasRole(user, allowedRoles, clubId = "") {
    if (!user) return false;
    return user.roles?.some((membership) =>
        allowedRoles.includes(membership.role) &&
        (membership.role === "super_admin" || !clubId || membership.club_id === clubId)
    ) || false;
}

export function destinationForUser(user, clubId = "") {
    if (!user) return "/login";
    const roles = user.roles || [];
    const inClub = (role) => roles.some((membership) => membership.role === role && (!clubId || membership.club_id === clubId));
    if (roles.some((membership) => membership.role === "super_admin") || inClub("club_admin")) return "/admin";
    if (inClub("coach") || inClub("staff")) return "/admin";
    if (inClub("parent")) return "/parent";
    // No player portal exists yet. Preserve a safe public destination rather
    // than rendering administrative UI for a player-only account.
    return "/";
}
